import { useContext, useEffect, useState, useCallback, useRef } from "react";
import DriveContext from "./context/driveContext";
import convertS3ToCloudFront from "../../../../utils/convertS3ToCloudFront";
import "./drive.css";
import {
  Button,
  Upload,
  Spin,
  message,
  Modal,
  Input,
  notification,
  Alert,
  Row,
  Card,
  Image,
  Col,
  Checkbox,
  Progress,
} from "antd";
import moment from "moment";
import { ImImages } from "react-icons/im";
import { FaArrowLeftLong } from "react-icons/fa6";

const MediaPage = () => {
  const {
    currentPage,
    apiBaseUrl,
    getAlbums,
    selectedAlbum,
    setSelectedAlbum,
    UploadZip,
    albumName,
    setAlbumName,
    userId,
    setCurrentPage,
  } = useContext(DriveContext);
  const [newMediaArray, setNewMediaArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tempMediaFiles, setTempMediaFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [checkedMedia, setCheckedMedia] = useState([]);
  const [checkedMediaIds, setCheckedMediaIds] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadAbortController, setUploadAbortController] = useState(null);
  const [uploadStats, setUploadStats] = useState({ uploaded: 0, total: 0 });
  const [selectedFilesForUpload, setSelectedFilesForUpload] = useState([]);
  const [currentUploadingFile, setCurrentUploadingFile] = useState("");

  // Use refs for upload state management
  const uploadStatsRef = useRef({ uploaded: 0, total: 0 });
  const isUploadingRef = useRef(false);
  const uploadAbortControllerRef = useRef(null);
  const fileInputRef = useRef(null);

  // Cleanup function to abort ongoing uploads
  const cleanupUploads = useCallback(() => {
    if (uploadAbortControllerRef.current) {
      uploadAbortControllerRef.current.abort();
      uploadAbortControllerRef.current = null;
    }
    isUploadingRef.current = false;
    setIsUploading(false);
    setUploadProgress(0);
    setUploadStats({ uploaded: 0, total: 0 });
    uploadStatsRef.current = { uploaded: 0, total: 0 };
    setCurrentUploadingFile("");
    setSelectedFilesForUpload([]);
    setTempMediaFiles([]);
  }, []);

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      cleanupUploads();
    };
  }, [cleanupUploads]);

  // Cleanup when modal is closed
  useEffect(() => {
    if (!isModalVisible) {
      resetUploadStates();
    }
  }, [isModalVisible]);
  // console.log(selectedAlbum);
  const handleCheckboxChange = (media) => {
    setCheckedMedia(
      (prevChecked) =>
        prevChecked.includes(media.link)
          ? prevChecked.filter((item) => item !== media.link) // Uncheck
          : [...prevChecked, media.link] // Check
    );
    setCheckedMediaIds(
      (prevChecked) =>
        prevChecked.includes(media._id)
          ? prevChecked.filter((item) => item !== media._id) // Uncheck
          : [...prevChecked, media._id] // Check
    );
  };
  const handleDownloadAll = () => {
    // console.log("Checked media:", checkedMedia);

    checkedMedia.forEach((link, index) => {
      setTimeout(() => {
        const anchor = document.createElement("a");
        anchor.href = link;
        anchor.download = link.split("/").pop(); // Extracts filename
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      }, index * 400); // Delay each download by 1 second
    });
  };
  const deleteMediaFromAlbum = async () => {
    const requestBody = {
      id: "679c9bb884bec91cef4b8758",
      type: "album",
      media: checkedMediaIds,
      albumId: selectedAlbum._id,
    };
    const response = await fetch(
      `${apiBaseUrl}/mediaAgencyRouter/deleteMediaFromTheAlbum`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      }
    );
    const data = await response.json();
    if (data.success) {
      notification.success({ message: data.message });
      setCheckedMedia([]);
      setCheckedMedia([]);
      setSelectedAlbum(data.updatedAlbum);
    }
  };
  const addMediaToAlbum = async (mediaArray) => {
    const requestBody = {
      albumId: selectedAlbum?._id,
      newMediaArray: mediaArray.length > 0 ? mediaArray : newMediaArray,
      subClientId: "679c9bb884bec91cef4b8758",
    };

    const response = await fetch(
      `${apiBaseUrl}/mediaAgencyRouter/addMediaToAlbum`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      }
    );
    const data = await response.json();
    if (data.success) {
      notification.success({ message: data.message });
      // setSelectedClient(data.updatedClient);
      setSelectedAlbum(data.updatedAlbum);
      setIsModalVisible(false);
    } else {
      notification.error({ message: data.message });
    }
  };
  // console.log(selectedAlbum);
  const resetUploadStates = () => {
    setUploadProgress(0);
    setUploadStats({ uploaded: 0, total: 0 });
    uploadStatsRef.current = { uploaded: 0, total: 0 };
    setCurrentUploadingFile("");
    setSelectedFilesForUpload([]);
    setTempMediaFiles([]);
    setIsUploading(false);
    isUploadingRef.current = false;
    setUploadAbortController(null);
    uploadAbortControllerRef.current = null;

    // Clear the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleCancel = () => {
    cleanupUploads();
    resetUploadStates();
    setIsModalVisible(false);
  };

  // Function to trigger file input click programmatically
  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleFileSelection = async (event) => {
    const files = Array.from(event.target.files);

    // File size validation (50MB limit per file)
    const maxFileSize = 100 * 1024 * 1024; // 100MB
    const oversizedFiles = files.filter((file) => file.size > maxFileSize);

    if (oversizedFiles.length > 0) {
      notification.error({
        message: "File size limit exceeded",
        description: `Files larger than 50MB are not allowed: ${oversizedFiles
          .map((f) => f.name)
          .join(", ")}`,
      });
      return;
    }

    setSelectedFilesForUpload(files);
    setTempMediaFiles(files);

    // Start upload immediately after file selection
    await handleFileUpload(files);
  };

  const handleFileUpload = async (filesToUpload = null) => {
    const files = filesToUpload || selectedFilesForUpload;

    if (files.length === 0) {
      notification.warning({
        message: "No files selected",
        description: "Please select files to upload.",
      });
      return;
    }

    // Create abort controller for this upload session
    const abortController = new AbortController();
    uploadAbortControllerRef.current = abortController;
    setUploadAbortController(abortController);

    setIsUploading(true);
    isUploadingRef.current = true;
    console.log("Upload started, isUploading set to true");

    let mediaArray = [];
    let uploadedCount = 0;
    setUploadProgress(0);
    setUploadStats({ uploaded: 0, total: files.length });
    uploadStatsRef.current = { uploaded: 0, total: files.length };
    setCurrentUploadingFile("");

    // Process files sequentially to avoid memory issues
    for (let i = 0; i < files.length; i++) {
      let file = files[i];

      try {
        // Update progress for current file
        setUploadProgress(Math.round((i / files.length) * 100));
        setUploadStats({ uploaded: i, total: files.length });
        uploadStatsRef.current = { uploaded: i, total: files.length };
        setCurrentUploadingFile(file.name);

        // Get upload policy
        const uploadPolicy = await UploadZip(file.name, file.type);

        if (!uploadPolicy || !uploadPolicy.data) {
          console.error("Failed to get upload policy for:", file.name);
          continue;
        }

        // Create form data
        const formData = new FormData();
        Object.keys(uploadPolicy.data.fields).forEach((key) => {
          formData.append(key, uploadPolicy.data.fields[key]);
        });
        formData.append("file", file, file.name);

        // Upload file
        const response = await fetch(uploadPolicy.data.url, {
          method: "POST",
          body: formData,
          signal: uploadAbortControllerRef.current?.signal,
        });

        if (response.ok) {
          const albumLink = convertS3ToCloudFront(
            `${uploadPolicy.data.url}/${uploadPolicy.data.fields.key}`,
          );

          const mediaItem = {
            link: albumLink,
            timestamp: new Date().toISOString(),
            uploadedBy: userId,
          };

          mediaArray.push(mediaItem);
          uploadedCount++;

          // Update progress
          setUploadProgress(Math.round((uploadedCount / files.length) * 100));
          setUploadStats({ uploaded: uploadedCount, total: files.length });
          uploadStatsRef.current = {
            uploaded: uploadedCount,
            total: files.length,
          };

          // Small delay to prevent overwhelming the browser
          await new Promise((resolve) => setTimeout(resolve, 100));
        } else {
          console.error(
            "Upload failed for:",
            file.name,
            "Status:",
            response.status
          );
          notification.error({
            message: `Upload failed for ${file.name}`,
            description: `Status: ${response.status}`,
          });
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("Upload aborted");
          return; // Exit the loop if upload was aborted
        }
        console.error("Error uploading file:", file.name, error);
        notification.error({
          message: `Error uploading ${file.name}`,
          description: error.message,
        });
      }

      // Clean up file reference
      file = null;
    }

    // Clear the file input and selected files
    setSelectedFilesForUpload([]);
    setTempMediaFiles([]);

    setIsUploading(false);
    isUploadingRef.current = false;
    console.log("Upload completed, isUploading set to false");
    setUploadAbortController(null);
    uploadAbortControllerRef.current = null;
    setUploadStats({ uploaded: 0, total: 0 });
    uploadStatsRef.current = { uploaded: 0, total: 0 };
    setCurrentUploadingFile("");

    if (mediaArray.length > 0) {
      await addMediaToAlbum(mediaArray);
      // Reset all states after successful upload
      resetUploadStates();
    } else {
      notification.warning({
        message: "No files uploaded",
        description: "Please try uploading your files again.",
      });
      // Reset states even if no files were uploaded
      resetUploadStates();
    }
  };

  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "20px",
      }}
      id="parent-padding-container"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "Center",
          width: "100%",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <FaArrowLeftLong
            onClick={() => {
              setCurrentPage("albums");
            }}
          />
          <h4 style={{ fontSize: "20px" }}>{selectedAlbum?.title}</h4>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {" "}
          <Button type="primary" onClick={() => setIsModalVisible(true)}>
            + Add New Media
          </Button>
          {checkedMedia.length > 0 && (
            <>
              <Button
                type="primary"
                onClick={handleDownloadAll}
                // style={{ marginBottom: "10px" }}
              >
                Download Selected
              </Button>
              {/* <Button
                type="danger"
                onClick={deleteMediaFromAlbum}
                // style={{ marginBottom: "10px" }}
              >
                Delete Selected
              </Button> */}
            </>
          )}
        </div>
      </div>

      <Row>
        {loading ? (
          <Spin
            tip="Loading media..."
            style={{
              margin: "auto",
              // height: '40vh',
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center",
            }}
          />
        ) : selectedAlbum.media.length > 0 ? (
          selectedAlbum.media.map((media, index) => {
            // Extract file extension from the link
            const fileExtension = media.link.split(".").pop().toLowerCase();

            return (
              <Col key={index} lg={6} md={8}>
                <Card
                  style={{
                    margin: "10px",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                  id="CardHoverCheck"
                  cover={
                    [
                      "jpg",
                      "jpeg",
                      "png",
                      "gif",
                      "bmp",
                      "tiff",
                      "tif",
                      "webp",
                      "svg",
                      "ico",
                      "heif",
                      "heic",
                      "avif",
                    ].includes(fileExtension) ? (
                      <Image
                        id="previewImage"
                        src={media.link} // Use link for the image source
                        style={{
                          objectFit: "cover",
                          height: "200px",
                          borderRadius: "8px",
                        }}
                      />
                    ) : [
                        "mp4",
                        "mkv",
                        "mov",
                        "avi",
                        "wmv",
                        "flv",
                        "webm",
                        "m4v",
                        "mpeg",
                        "mpg",
                        "3gp",
                        "ogv",
                        "vob",
                        "mts",
                        "ts",
                      ].includes(fileExtension) ? (
                      <video
                        controls
                        style={{
                          objectFit: "cover",
                          height: "200px",
                          width: "100%",
                          borderRadius: "8px",
                        }}
                      >
                        <source
                          src={media.link}
                          type={`video/${fileExtension}`}
                        />
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      <ImImages
                        style={{ fontSize: "100px", color: "#d2d9ea" }}
                      />
                    )
                  }
                >
                  {/* {user?.post == 'admin' && (
													<input
														type="checkbox"
														id="CheckBox"
														checked={checkedData.includes(media.name)}
														onChange={e => handleCheckboxChange(e, media)}
													/>
												)} */}
                  <Checkbox
                    checked={checkedMediaIds.includes(media._id)}
                    onChange={() => handleCheckboxChange(media)}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      // background: "white",
                      borderRadius: "4px",
                      // padding: "2px",
                    }}
                  />

                  <Card.Meta
                    title={media.link.split("/").pop()} // Extracts the file name from the link
                    description={`Uploaded on : ${moment(
                      media.timestamp
                    ).format("DD-MM-YYYY")}`}
                  />
                  <a
                    href={media.link}
                    download={media.name}
                    style={{
                      marginTop: "10px",
                      color: "#007bff",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    Download
                  </a>
                </Card>
              </Col>
            );
          })
        ) : (
          <p>No media found in this album</p>
        )}
      </Row>
      <Modal
        title="Upload Media Files"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        {/* <Spin spinning={isUploading} tip="Uploading..."> */}
          <div style={{ marginBottom: "15px" }}>
            {/* Hidden file input */}
            <input
              type="file"
              multiple
              onChange={handleFileSelection}
              accept="image/*,video/*,audio/*"
              disabled={isUploading}
              ref={fileInputRef}
              style={{ display: "none" }}
            />

            {/* Custom styled file input button */}
            <Button
              type="primary"
              onClick={triggerFileInput}
              disabled={isUploading}
              style={{ marginBottom: "10px" }}
            >
              Choose Files
            </Button>

            {selectedFilesForUpload.length > 0 && !isUploading && (
              <p style={{ marginTop: "10px", color: "#666" }}>
                {selectedFilesForUpload.length} file(s) selected
              </p>
            )}
          </div>

          {/* Display progress bar if uploading */}
          {(isUploading || uploadStats.total > 0) && (
            <>
              <div
                style={{
                  marginTop: "20px",
                  textAlign: "center",
                  padding: "20px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  border: "1px solid #e9ecef",
                }}
              >
                <p
                  style={{
                    marginBottom: "15px",
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: "#1890ff",
                  }}
                >
                  📤 Uploading Files...
                </p>
                <p
                  style={{
                    marginBottom: "15px",
                    color: "#666",
                    fontSize: "16px",
                  }}
                >
                  {uploadStats.uploaded} of {uploadStats.total} files uploaded
                </p>
                {currentUploadingFile && (
                  <p
                    style={{
                      marginBottom: "20px",
                      color: "#1890ff",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    Currently uploading: {currentUploadingFile}
                  </p>
                )}
                <Progress
                  percent={uploadProgress}
                  status="active"
                  strokeColor="#1890ff"
                  strokeWidth={8}
                  style={{ marginBottom: "20px" }}
                />
                {/* <Button
                  danger
                  onClick={cleanupUploads}
                  style={{ marginTop: "10px" }}
                >
                  Cancel Upload
                </Button> */}
              </div>
            </>
          )}

          {/* <div style={{ marginTop: "20px" }}>
            {tempMediaFiles.map((file, index) => (
              <p key={index}>
                {file.name} - {(file.size / 1024).toFixed(2)} KB
              </p>
            ))}
          </div> */}
        {/* </Spin> */}
      </Modal>
    </div>
  );
};
export default MediaPage;
